module.exports = __webpack_public_path__ + "static/media/contact-square.8ec66efb.svg";